import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './contexts/ToastContext';
import AuthGuard from './components/AuthGuard';
import LoginGuard from './components/LoginGuard';
import RoleGuard from './components/RoleGuard';
import Layout from './components/Layout';
import SuperAdminLayout from './components/SuperAdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import HeroSection from './pages/HeroSection';
import AboutSection from './pages/AboutSection';
import ServicesSection from './pages/ServicesSection';
import HowItWorksSection from './pages/HowItWorksSection';
import OurTeamSection from './pages/OurTeamSection';
import BlogsSection from './pages/BlogsSection';
import TestimonialsSection from './pages/TestimonialsSection';
import PricingSection from './pages/PricingSection';
import ServicesPage from './pages/ServicesPage';
import ContactSection from './pages/ContactSection';
import SuperAdminApproval from './pages/SuperAdminApproval';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <div className="App">
            <Routes>
              {/* Login Route */}
              <Route 
                path="/login" 
                element={
                  <LoginGuard>
                    <Login />
                  </LoginGuard>
                } 
              />

              {/* Admin Routes (with sidebar) */}
              <Route
                path="/"
                element={
                  <AuthGuard>
                    <RoleGuard allowedRoles={['admin']}>
                      <Layout />
                    </RoleGuard>
                  </AuthGuard>
                }
              >
                <Route index element={<Navigate to="/dashboard" replace />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="hero-section" element={<HeroSection />} />
                <Route path="about-section" element={<AboutSection />} />
                <Route path="services-section" element={<ServicesSection />} />
                <Route path="how-it-works-section" element={<HowItWorksSection />} />
                <Route path="our-team-section" element={<OurTeamSection />} />
                <Route path="blogs-section" element={<BlogsSection />} />
                <Route path="testimonials-section" element={<TestimonialsSection />} />
                <Route path="pricing-section" element={<PricingSection />} />
                <Route path="services-page" element={<ServicesPage />} />
                <Route path="contact-section" element={<ContactSection />} />
              </Route>

              {/* Super Admin Routes (no sidebar) */}
              <Route
                path="/super-admin"
                element={
                  <AuthGuard>
                    <RoleGuard allowedRoles={['super_admin']}>
                      <SuperAdminLayout />
                    </RoleGuard>
                  </AuthGuard>
                }
              >
                <Route index element={<Navigate to="/super-admin/approval" replace />} />
                <Route path="approval" element={<SuperAdminApproval />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
